import Instances from './instances.view.vue';
import InstanceDataTable from './instances-datatable/instances-datatable.component.vue'

export default [
  {
    path: '/instances',
    name: 'instances',
    component: Instances,
    children: [
      {
        path: '/instances/',
        name: 'InstanceDataTable',
        component: InstanceDataTable,
      },
    ],
  },
];
